import { combineReducers } from 'redux';
import errorsSlice from 'redux/errors.slice';
import { reducer as deliveryRecipients } from 'routes/placeScroll/NoticeDelivery/deliveryRecipients.slice';

const makeRootReducer = () => {
  return combineReducers({
    errors: errorsSlice,
    auth: require('../redux/auth').reducer,
    placement: require('../redux/placement').reducer,
    toast: require('../redux/toast').reducer,
    notices: require('../redux/notices').reducer,
    deliveryRecipients
  });
};

export const injectReducer = (store: any, { key, reducer }: any) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;
  // eslint-disable-next-line no-param-reassign
  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer());
};

export default makeRootReducer;
